(function($) {
    $(function() {
        var $trigger = $('.secondary-menu-trigger'),
            $menu = $('.secondary-navigation');

        //Open the menu on mobile
        $trigger.on('click', function(e) {
            $(this).toggleClass('is-active');
            $menu.toggleClass('open-menu');
        });
    });
})(jQuery);